// Road and urban noise maps 2022 (CNOSSOS-EU) from Umhverfis- og
// orkustofnun's GeoServer, the same data as kortasja.ust.is. Only mapped
// towns are covered. Our SLD keeps the standard noise colours but drops the
// "< 50 dB" class, which UST fills white and would wash out the map.
export const NOISE_WMS_URL = "https://gis.ust.is/geoserver/wms";

export const NOISE_ATTRIBUTION =
  'Noise maps 2022 &copy; <a href="https://ust.is/hringrasarhagkerfi/hollustuhaettir/havadi-og-hljodvist/havadakort/">Umhverfis- og orkustofnun</a>';

// dB classes of the isov1 attribute, as on UST's own maps
export const NOISE_CLASSES = [
  { label: "50", from: "50", to: "54", color: "#a0fa28" },
  { label: "55", from: "55", to: "59", color: "#ffff00" },
  { label: "60", from: "60", to: "64", color: "#ff9600" },
  { label: "65", from: "65", to: "69", color: "#ff0000" },
  { label: "70", from: "70", to: "74", color: "#00a0f0" },
  { label: "75+", from: "75", to: null, color: "#0000b4" },
];

export const NOISE_PERIODS = {
  day: { layer: "INSPIRE:havadi2022lden", label: "Day", unit: "Lden" },
  night: { layer: "INSPIRE:havadi2022nott", label: "Night", unit: "Ln" },
};

const literal = (value) => `<ogc:Literal>${value}</ogc:Literal>`;
const property = "<ogc:PropertyName>isov1</ogc:PropertyName>";

const classRule = ({ from, to, color }) => {
  const filter = to
    ? `<ogc:PropertyIsBetween>${property}<ogc:LowerBoundary>${literal(from)}</ogc:LowerBoundary><ogc:UpperBoundary>${literal(to)}</ogc:UpperBoundary></ogc:PropertyIsBetween>`
    : `<ogc:PropertyIsGreaterThanOrEqualTo>${property}${literal(from)}</ogc:PropertyIsGreaterThanOrEqualTo>`;
  return `<Rule><ogc:Filter>${filter}</ogc:Filter><PolygonSymbolizer><Fill><CssParameter name="fill">${color}</CssParameter></Fill></PolygonSymbolizer></Rule>`;
};

const paramsFor = ({ layer }) => ({
  layers: layer,
  styles: "",
  format: "image/png",
  transparent: true,
  sld_body: `<StyledLayerDescriptor version="1.0.0" xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc"><NamedLayer><Name>${layer}</Name><UserStyle><FeatureTypeStyle>${NOISE_CLASSES.map(classRule).join("")}</FeatureTypeStyle></UserStyle></NamedLayer></StyledLayerDescriptor>`,
});

// Built once so the tile layer gets a stable params object
export const NOISE_PARAMS = {
  day: paramsFor(NOISE_PERIODS.day),
  night: paramsFor(NOISE_PERIODS.night),
};
